import { stringify } from 'qs'

import { lsGet, safeAwait } from 'utils/request'

export const getAlbumCount = (props) => {
  return safeAwait(lsGet(`/albums/count?${stringify(props)}`))
}
